import { render, staticRenderFns } from "./CardknoxProvider.vue?vue&type=template&id=374d705c&"
import script from "./CardknoxProvider.vue?vue&type=script&lang=ts&"
export * from "./CardknoxProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports